export const API_WEB_URLS = {

  BASE: "https://apifueltally.shinewellinnovation.com/api/V1/",
  // BASE: "http://192.168.1.5:7037/api/V1/",

  LOGIN: "Authentication/Login",
  //IMAGEURL: "https://localhost:44362/MemberImages/",
  IMAGEURL: "http://192.168.155.89:7037/MemberImages/",
  IMAGEURL_PDF:
    "http://apicollegedesktop.shinewellinnovation.com/MemberImages/PDF/",
  //
  MASTER: "Masters",
  STUDENTCOURSEMAPDETAILS: "Masters/0/token/StudentCourseMap/Id/",
  STUDENTCOURSEMAPDETAILS_OtherData:
    "Masters/0/token/StudentCourseMap_OtherData/Id/",

  FeesScheduleDetails_OtherData:
    "Masters/0/token/FeesScheduleList_OtherData/Id/",
  FeesScheduleDetails: "Masters/0/token/FeesSchedule_CourseId/Id/",

  CourseFormWithAmount: "Masters/0/token/CourseFormWithAmount/Id/",
  StudentWithAdmissionNo: "Masters/0/token/StudentWithAdmissionNo/Id/",
  RequestMasterDetails_OtherData: "Masters/0/token/RequestMaster_OtherData/Id/",

  CourseMapDataByRegistrationId:
    "Masters/0/token/CourseMapDataByRegistrationId/Id/",
  NotVerifiedPayment: "Masters/0/token/NotVerifiedPayment/Id/",

  StockMaster_OtherData: "Masters/0/token/StockMaster_OtherData/Id/",

  ChapterDetails_OtherData: "Masters/0/token/GetOnlineVideoDetail_Chapter/Id/",
  ChapterDetails_NotesData: "Masters/0/token/GetNotesDetail_Chapter/Id/",
  DesktopData: "Masters/0/token/DesktopData/Id/",
  MCQTotalScoreData: "Masters/0/token/MCQTotalScoreData/Id/",

  RackDetails_OtherData:
    "Masters/0/token/RackDetails_OtherData/Id/",
  Certificate : 'Certificate',
  ProductMaster : 'ProductMaster',
  PointsMaster : 'PointsMaster',
  AddRate : 'AddRate',
  WorkerMaster : 'WorkerMaster',
  PumpMaster : 'PumpMaster',
  ItemTypeMaster : 'ItemTypeMaster',
  CUSTOMER: "CustomerMaster",
  FirmMaster: "FirmMaster",
  BranchMaster: "BranchMaster",
  UserMaster: "UserMaster",
  UserMaster: "UserMaster",
  CourseMasterH: "CourseMasterH",
  CourseMasterL: "CourseMasterL",
  PlanH: "PlanH",
  PlanL: "PlanL",
  McqMasterH : 'McqMasterH',
  McqMasterL : 'McqMasterL',
  SearchPlan: "SearchPlan",
  CouponMaster: "CouponMaster",
  QrImage : 'QrImage',
  VerifyUtr : 'VerifyUtr',

  TypeMaster: "TypeMaster",
  PartnerMaster: "PartnerMaster",
  CourseAndYear: "CourseAndYear",
  CourseRunAndStop: "CourseRunAndStop",
  TeamLeader: "TeamLeader",
  StudentMaster: "StudentMaster",
  StateMaster: "StateMaster",
  CityMaster: "CityMaster",
  CountryMaster: "CountryMaster",
  PaymentSentAndViewLedger: "PaymentSentAndViewLedger",
  VerifyByCollege: "VerifyByCollege",
  OnlineVideoAddMaster: "OnlineVideoAddMaster",
  TeacherMaster: "TeacherMaster",
  MCQMaster: "MCQMaster",
  OnlineVideoCommentMaster: "OnlineVideoCommentMaster",
  NotesMaster: "NotesMaster",
  CollegeMaster: "CollegeMaster",
  OrganisationMaster: "OrganisationMaster",
  CollegeBranchMaster: "CollegeBranchMaster",
  UserMasterNew: "UserMasterNew",
  UserTypeMaster: "UserTypeMaster",
  LedgerMaster: "LedgerMaster",
  BankAccountMaster: "BankAccountMaster",
  StaffDocumentUploadMaster: "StaffDocumentUploadMaster",
  DocumentTypeMaster: "DocumentTypeMaster",
  ItemTypeMaster: "ItemTypeMaster",
  UnitMaster: "UnitMaster",
  ItemMaster: "ItemMaster",
  ClassLab: "ClassLab",
  ClassItemMap: "ClassItemMap",
  StockMaster: "StockMaster",
  NotesCommentMaster: "NotesCommentMaster",
  AuthorMaster: "AuthorMaster",
  BookMaster: "BookMaster",
  BookTypeMaster: "BookTypeMaster",
  RackMaster: "RackMaster",
  SupplierMaster: "SupplierMaster",
  PurchaseMaster: "PurchaseMaster",
  RackCapacityMapWithUniqueAccountNo : "RackCapacityMapWithUniqueAccountNo",
  TeacherDocumentMapMaster :"TeacherDocumentMapMaster",
  ManageVouchers :"ManageVouchers",
  
  //Reports
  StudentDetails: "StudentDetails",
  StudentLedgerDetails: "StudentLedgerDetails",
  AttendanceReport: "AttendanceReport",
  StudentReport: "StudentReport",
  StudentLessonDetails: "StudentLessonDetails",
  BalanceSheet: "BalanceSheet",
  BalanceSheetAssest : "BalanceSheetAssest",
  TeachersReport: "TeachersReport",
  //KreditBEast
  PropertyDeal: "PropertyDeal",

  Token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImluZm9Ac2hpbmV3ZWxsaW5ub3ZhdGlvbi5jb20iLCJuYW1laWQiOiIxIiwidW5pcXVlX25hbWUiOiIzMTZiYmI3Ny1kOWIxLTQwNWYtYWRiYy01YzYyN2I0M2YwOWQiLCJJUCI6IjQ5LjQzLjE3Ni45NSIsImlzc3VlZF9kYXRlIjoiMTY5NDQzMjU3MyIsIm5iZiI6MTY5NDQzMjU3MywiZXhwIjoxNjk1MDM3MzczLCJpYXQiOjE2OTQ0MzI1NzMsImlzcyI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSIsImF1ZCI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSJ9.thpdYXJuKWTDlStV-HHTv6PViEDZPrSQDO9C3aUo4mM",
};